import { NgModule } from '@angular/core';

// #region all modules

import { G2BarModule } from '@ohayojp/chart/bar';
import { G2CardModule } from '@ohayojp/chart/card';
import { G2CustomModule } from '@ohayojp/chart/custom';
import { G2GaugeModule } from '@ohayojp/chart/gauge';
import { G2MiniAreaModule } from '@ohayojp/chart/mini-area';
import { G2MiniBarModule } from '@ohayojp/chart/mini-bar';
import { G2MiniProgressModule } from '@ohayojp/chart/mini-progress';
import { NumberInfoModule } from '@ohayojp/chart/number-info';
import { G2PieModule } from '@ohayojp/chart/pie';
import { G2RadarModule } from '@ohayojp/chart/radar';
import { G2SingleBarModule } from '@ohayojp/chart/single-bar';
import { G2TagCloudModule } from '@ohayojp/chart/tag-cloud';
import { G2TimelineModule } from '@ohayojp/chart/timeline';
import { TrendModule } from '@ohayojp/chart/trend';
import { G2WaterWaveModule } from '@ohayojp/chart/water-wave';

const MODULES = [
  G2BarModule,
  G2CardModule,
  G2CustomModule,
  G2GaugeModule,
  G2MiniAreaModule,
  G2MiniBarModule,
  G2MiniProgressModule,
  G2PieModule,
  G2RadarModule,
  G2TagCloudModule,
  G2TimelineModule,
  G2WaterWaveModule,
  G2SingleBarModule,
  NumberInfoModule,
  TrendModule,
];

// #endregion

@NgModule({ exports: MODULES })
export class OhayoChartModule { }
